/**
 * Created by rorschach on 2018/1/26.
 */
export const URL_INDEX = "/";
export const URL_LOGIN = "/login";
export const URL_HOME = "/home";
export const Test_TOKEN = "zkN39ViGrstVkiSD8d2LtDWBwYf3Nd";
// export const APP_ID = "wxe8da7579dd1a8a2c"; //测试版
// export const APP_SECRET = "1653354b98ce3dd4ff0f0984eef05357"; //测试版
export const APP_ID = "wxbe19aba223c2632a"; //正式版
export const APP_SECRET = "ac28865b455453b6feb7b895f1277897"; //正式版
export const MY_OPENID = "ol6tyuOm8XBK4Kkbdm9nPi3N1Nhc"; //我的openid

export const STORAGE_KEYS_NS = "diandian-works";
export const SEARCH_NULL = "搜索结果为空";
export const STORAGE_KEYS = {
  token: `${STORAGE_KEYS_NS}/token`,
  user_id: `${STORAGE_KEYS_NS}/user_id`
};

export const BRAND_LINK_SINGLE = [];

export const pList = [
  "13968316802",
  "18324759989",
  "15309460265",
  "15610158380",
  "13816539851"
  // "17573046926"
];

export const GENDER_VALS = {
  UNKNOWN: 0,
  MALE: 1,
  FEMALE: 2
};

export const USER_REG_STEPS = {
  HOME: 0,
  TERM: 1,
  COMPLETE3: 2,
  COMPLETE2: 3,
  COMPLETE1: 4,
  ROLE_CHOOSE: 5,
  PHONE_BIND: 6
};
export const HTTP_CODE_SUCCESS = 1000;
export const HTTP_CODE_NEED_AUTH_ARRAY = [1005, 1001];
export const BLANK_IMAGE_BASE64_URL =
  "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";



// WEBPACK FOOTER //
// ./src/consts/consts.js